<div class="topbar" *ngIf="!recent">
  <h4 class="topbar-title">
    {{ source === 'mo' ? 'Origin' : '' }} Country(MCC)/Network(MNC)
    <span
      class="icon-help-1 ml-15"
      [tooltip]="
        source === 'mo'
          ? 'Select the network from which you would like to send the MO SMS from the list of available networks below.'
          : 'Select the network you would like to test from the list of available networks below.'
      "
      tooltipPlacement="top"></span>
  </h4>
  <div class="right-icons">
    <a tooltip="Add custom test numbers" tooltipPlacement="top" *ngIf="showManualAddNumbers" (click)="onClickAddPhonenumbers()"
      ><span class="icon-add-phone-numbers"></span
    ></a>
    <a *ngIf="source !== 'mo' && source !== 'voice'" tooltip="Download available Networks as xlsx" tooltipPlacement="top" (click)="onClickExport()"
      ><span class="icon-export"></span
    ></a>
  </div>
</div>
<div *ngIf="!recent" class="topbar-search">
  <input
    type="text"
    class="form-control select-input"
    placeholder="Select country & network"
    #searchInput
    (input)="onSearchQueryChange($event)"
    [disabled]="isAllDisabled"
    pm-ignore />
  <span class="icon-search search-icon"></span>
  <a class="ported-button" role="button" tooltip="Filter networks" tooltipPlacement="top">
    <i class="icon-filter-1" [ngClass]="{ applied: showOnlyPorted || hidePorted || showOnlyRcs || showOnlyFlashCall }"></i>
  </a>
  <div class="ported-options ms-10">
    <div class="d-flex flex-column py-15">
      <span class="text-neutral-n6 px-10 pb-10">Show only </span>
      <div class="d-flex px-10 py-0_5 gap-10 cp" (click)="onShowOnlyPorted($event)">
        <div class="input-check">
          <input type="checkbox" [ngModel]="showOnlyPorted" [ngModelOptions]="{ standalone: true }" class="form-check-input" />
        </div>
        <span class="select-text">Ported</span>
      </div>
      <div class="d-flex px-10 py-0_5 gap-10 cp" (click)="onHidePortedClick($event)">
        <div class="input-check">
          <input type="checkbox" [ngModel]="hidePorted" [ngModelOptions]="{ standalone: true }" class="form-check-input" />
        </div>
        <span class="select-text">Not ported</span>
      </div>
      <div class="px-10">
        <hr />
      </div>
      <div
        *ngIf="source === 'live' || source === 'live-rcs' || source === 'live-flash-call' || source === 'manual' || source === 'manual-rcs'"
        class="d-flex px-10 py-0_5 gap-10 cp"
        (click)="onShowRcsClick($event)">
        <div class="input-check">
          <input type="checkbox" [ngModel]="showOnlyRcs" [ngModelOptions]="{ standalone: true }" class="form-check-input" />
        </div>
        <span class="select-text">RCS</span>
      </div>
      <div *ngIf="showFlashCallOption" class="d-flex px-10 py-0_5 gap-10 cp"
        [class.text-muted]="!flashCallAvailable"
        [title]="flashCallAvailable ? '' : 'Add Flash call to your package. Contact your account manager.'"
        (click)="onShowFlashCallClick($event)">
        <div class="input-check">
          <input type="checkbox" [disabled]="!flashCallAvailable" [ngModel]="showOnlyFlashCall" [ngModelOptions]="{ standalone: true }" class="form-check-input" />
        </div>
        <span class="select-text">Flash call</span>
        <span class="new-pill ms-auto align-self-center">New</span>
      </div>
    </div>
  </div>
</div>

<div *ngIf="recent" class="filter-input-section d-flex justify-space-between align-items-center">
  <input
    placeholder="Search by destination or network"
    class="form-control"
    #searchInput
    (input)="onSearchQueryChange($event)"
    type="text"
    [disabled]="isAllDisabled"
    pm-ignore />
  <span class="icon-search position-absolute"></span>
  <span tooltip="Clear all selected destinations" class="far fa-trash-alt" (click)="onDeleteFilterClick()"></span>
</div>

<!-- For component -->
<ul *ngIf="!recent" class="nav nav-tabs" id="myTab" role="tablist" [ngClass]="{ 'pb-0_8': source === 'mo' }">
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link active"
      id="all-tab"
      data-bs-toggle="tab"
      data-bs-target="#all"
      type="button"
      role="tab"
      aria-controls="all"
      aria-selected="true">
      All
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link"
      id="fav-tab"
      data-bs-toggle="tab"
      data-bs-target="#fav"
      type="button"
      role="tab"
      aria-controls="fav"
      aria-selected="false">
      Favourites
      <span *ngIf="getFavourites().length as favouritesCount">({{ favouritesCount }})</span>
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeTab()"
      class="nav-link"
      id="selected-tab"
      data-bs-toggle="tab"
      data-bs-target="#selected"
      type="button"
      role="tab"
      aria-controls="selected"
      aria-selected="false">
      Selected
      <span *ngIf="getSelectedModels().length as selectedCount">({{ selectedCount }})</span>
    </button>
  </li>
</ul>
<div *ngIf="!recent" class="destination-wrapper" #destinationWrapper>
  <div class="tab-content" id="myTabContent">
    <div *ngIf="loading" class="d-flex justify-content-center align-items-center py-30">
      <div class="loader"></div>
    </div>
    <div *ngIf="!loading" class="tab-pane mix-select-box fade show active" id="all" role="tabpanel" aria-labelledby="all-tab">
      <div class="list-row" (click)="onClickToggleAll()" *ngIf="source !== 'mo'">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="toggleAll" />
        </div>
        <div class="text">Select all</div>
        <div class="actions"></div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="30" [style.height.px]="30 * rowsVisible" #scrollViewportAll>
        <div
          class="list-row"
          *cdkVirtualFor="let d of getDestinations() | filterText: searchQuery : ['__search']"
          (click)="toggle(d); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [ngModel]="d.selected"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isDisable(d)" />
          </div>
          <div class="text" *ngIf="!d.custom" [tooltip]="getTooltip(d)" tooltipPlacement="top">
            {{ d.countryName }}({{ d.mcc }})/{{ d.providerName }}({{ d.mnc }})
            <span *ngIf="d.originalProviderName && d.originalMnc">
              <i class="icon-ported"></i> {{ d.originalProviderName }}({{ d.originalMnc }})
            </span>
          </div>
          <div class="text" *ngIf="d.custom">
            <ng-container *ngIf="d.countryName">{{ d.countryName }}/</ng-container>{{ d.phonenumber }}
          </div>
          <div class="actions">
            <div class="icon-favourite-wrapper" (click)="onFavouriteClick(d); $event.stopPropagation()">
              <span *ngIf="!recent && !d.custom" class="icon-favourite" [ngClass]="{ marked: d.isFavourite }"></span>
            </div>
          </div>
        </div>
        <div *ngIf="!recent && (source === 'live' || source === 'manual')" class="mt-10">
          <a [routerLink]="['/analytics/coverage']" target="_blank" class="d-flex justify-content-between align-items-center coverage-button">
            <span class="text-neutral-n7"> Can't find your network? </span>
            <span class="text-primary"> Make a request > </span>
          </a>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
    <div class="tab-pane mix-select-box fade" id="fav" role="tabpanel" aria-labelledby="fav-tab" *ngIf="getFavourites() as favourites">
      <div *ngIf="favourites.length > 0 && source !== 'mo'" class="list-row" (click)="onClickToggleAllFavorites()">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="toggleAllFavourites" />
        </div>
        <div class="text">Select all</div>
        <div class="actions"></div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="30" [style.height.px]="30 * rowsVisible" #scrollViewportFavorites>
        <div class="list-row" *ngFor="let d of favourites" (click)="toggle(d); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [ngModel]="d.selected"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isDisable(d)" />
          </div>
          <div class="text" *ngIf="!d.custom" [tooltip]="getTooltip(d)" tooltipPlacement="top">
            {{ d.countryName }}({{ d.mcc }})/{{ d.providerName }}({{ d.mnc }})
            <span *ngIf="d.originalProviderName && d.originalMnc">
              <i class="icon-ported"></i> {{ d.originalProviderName }}({{ d.originalMnc }})
            </span>
          </div>
          <div class="text" *ngIf="d.custom">
            <ng-container *ngIf="d.countryName">{{ d.countryName }}/</ng-container>{{ d.phonenumber }}
          </div>
          <div class="actions">
            <div class="icon-favourite-wrapper" (click)="onFavouriteClick(d); $event.stopPropagation()">
              <span *ngIf="!recent && !d.custom" class="icon-favourite" [ngClass]="{ marked: d.isFavourite }"></span>
            </div>
          </div>
        </div>
        <div class="list-row text-center mt-20 text-neutral-n6" *ngIf="favourites.length === 0">No Favourites</div>
      </cdk-virtual-scroll-viewport>
    </div>
    <div
      class="tab-pane mix-select-box fade"
      id="selected"
      role="tabpanel"
      aria-labelledby="selected-tab"
      *ngIf="getSelectedModels() as selectedModels">
      <div *ngIf="selectedModels.length && source !== 'mo'" class="select-list d-flex align-items-center justify-content-between">
        <div class="list-row" (click)="onDeleteFilterClick()">
          <div class="input-check">
            <input class="form-check-input" type="checkbox" checked />
          </div>
          <span class="text">Clear all</span>
          <div class="actions"></div>
        </div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="30" [style.height.px]="30 * rowsVisible" #scrollViewportSelected>
        <div class="list-row" *cdkVirtualFor="let d of selectedModels" (click)="toggle(d); $event.stopPropagation()">
          <div class="input-check">
            <input
              class="form-check-input"
              type="checkbox"
              [ngModel]="d.selected"
              [ngModelOptions]="{ standalone: true }"
              [disabled]="isDisable(d)" />
          </div>
          <div class="text" *ngIf="!d.custom" [tooltip]="getTooltip(d)" tooltipPlacement="top">
            {{ d.countryName }}({{ d.mcc }})/{{ d.providerName }}({{ d.mnc }})
            <span *ngIf="d.originalProviderName && d.originalMnc">
              <i class="icon-ported"></i> {{ d.originalProviderName }}({{ d.originalMnc }})
            </span>
          </div>
          <div class="text" *ngIf="d.custom">
            <ng-container *ngIf="d.countryName">{{ d.countryName }}/</ng-container>{{ d.phonenumber }}
          </div>
          <div class="actions">
            <div class="icon-favourite-wrapper" (click)="onFavouriteClick(d); $event.stopPropagation()">
              <span *ngIf="!recent && !d.custom" class="icon-favourite" [ngClass]="{ marked: d.isFavourite }"></span>
            </div>
          </div>
        </div>
        <div *ngIf="!selectedModels.length" class="list-row text-center mt-20 text-neutral-n6">No network selected</div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

<!-- For search filter -->
<ul *ngIf="recent" class="nav nav-tabs" id="myFilterTab" role="tablist">
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeSearchFilterTab()"
      class="nav-link active"
      id="allfilter-tab"
      data-bs-toggle="tab"
      data-bs-target="#allfilter"
      type="button"
      role="tab"
      aria-controls="allfilter"
      aria-selected="true">
      All
    </button>
  </li>
  <li class="nav-item" role="presentation">
    <button
      (click)="onChangeSearchFilterTab()"
      class="nav-link"
      id="selectedfilter-tab"
      data-bs-toggle="tab"
      data-bs-target="#selectedfilter"
      type="button"
      role="tab"
      aria-controls="selectedfilter"
      aria-selected="false">
      Selected
      <span *ngIf="getSelectedModels().length as selectedCount">({{ selectedCount }})</span>
    </button>
  </li>
</ul>
<div *ngIf="recent" class="destination-wrapper restrict">
  <div class="tab-content cn-wrapper" id="myFilterTabContent">
    <div *ngIf="loading" class="d-flex justify-content-center align-items-center py-30">
      <div class="loader"></div>
    </div>
    <div *ngIf="!loading" class="tab-pane mix-select-box fade show active" id="allfilter" role="tabpanel" aria-labelledby="allfilter-tab">
      <div class="list-row" (click)="onClickToggleAll()">
        <div class="input-check">
          <input class="form-check-input" type="checkbox" [(ngModel)]="toggleAll" />
        </div>
        <div class="text">Select all</div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="32" class="filter-viewport" #scrollViewportAll>
        <div
          class="pt-0_2"
          *cdkVirtualFor="let d of getDestinations() | filterText: searchQuery : ['__search']; trackBy: trackByMccMnc"
          (click)="toggle(d); $event.stopPropagation()">
          <div class="list-row">
            <div class="input-check">
              <input
                class="form-check-input"
                type="checkbox"
                [ngModel]="d.selected"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDisable(d)" />
            </div>
            <div class="text" [tooltip]="getTooltip(d)" tooltipPlacement="top">
              {{ d.countryName }}({{ d.mcc }})/{{ d.providerName }}({{ d.mnc }})
            </div>
            <div class="actions">
              <div class="icon-favourite-wrapper" (click)="toggleGearContainer(d); $event.stopPropagation()">
                <span
                  class="icon-settings text-neutral-n6"
                  [ngClass]="{ applied: filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'SPECIFIC' }"></span>
              </div>
            </div>
          </div>
          <div class="gear-container" *ngIf="selectedDestinationToShowGearOptions === d" (click)="$event.stopPropagation()">
            <span class="gear-title">Ported from</span>
            <div class="d-flex align-items-center my-10 gap-10">
              <input
                type="radio"
                name="portedfrom_{{ d.mnc }}_all"
                class="form-check-input cp"
                [checked]="filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'ALL'"
                (click)="onAllFilterPortedClick(d)" />
              <label>All ported numbers</label>
            </div>
            <div class="d-flex align-items-center my-10 gap-10">
              <input
                type="radio"
                name="portedfrom_{{ d.mnc }}_all"
                class="form-check-input cp"
                [checked]="filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'SPECIFIC'"
                (click)="onSpecificFilterPortedClick(d)" />
              <label>Specific ported MNCs</label>
            </div>
            <div class="w-75 ms-20 mb-15">
              <input
                class="form-control"
                type="text"
                placeholder="01,02"
                (input)="onSpecificMNCInputChange($event, d)"
                [formControl]="currentPortedMNCFormControl" />
              <input-errors class="mt-10" [control]="currentPortedMNCFormControl" [service]="validationService"></input-errors>
            </div>
            <div class="gear-buttons d-flex justify-content-end align-items-center gap-10">
              <button class="btn btn-sm btn-outline-dark px-10" (click)="onFilterPortedCancelClick(d); $event.stopPropagation()">Cancel</button>
              <button
                class="btn btn-sm btn-primary px-10"
                [disabled]="!currentPortedMNCFormControl.valid"
                (click)="onFilterPortedSubmitClick(d); $event.stopPropagation()">
                Submit
              </button>
            </div>
          </div>
        </div>
      </cdk-virtual-scroll-viewport>
    </div>

    <div
      class="tab-pane mix-select-box fade"
      id="selectedfilter"
      role="tabpanel"
      aria-labelledby="selectedfilter-tab"
      *ngIf="getSelectedModels() as selectedModels">
      <div *ngIf="selectedModels.length" class="select-list d-flex align-items-center justify-content-between">
        <div class="list-row" (click)="onDeleteFilterClick()">
          <div class="input-check">
            <input class="form-check-input" type="checkbox" checked />
          </div>
          <span class="text">Clear all</span>
        </div>
      </div>
      <cdk-virtual-scroll-viewport itemSize="32" class="filter-viewport" #scrollViewportSelected>
        <div class="pt-0_2" *cdkVirtualFor="let d of selectedModels" (click)="toggle(d); $event.stopPropagation()">
          <div class="list-row">
            <div class="input-check">
              <input
                class="form-check-input"
                type="checkbox"
                [ngModel]="d.selected"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="isDisable(d)" />
            </div>
            <div class="text w-100">{{ d.countryName }}({{ d.mcc }})/{{ d.providerName }}({{ d.mnc }})</div>
            <div class="actions">
              <div class="icon-favourite-wrapper" (click)="toggleGearContainer(d); $event.stopPropagation()">
                <span
                  class="icon-settings text-neutral-n6"
                  [ngClass]="{ applied: filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'SPECIFIC' }"></span>
              </div>
            </div>
          </div>
          <div class="gear-container" *ngIf="selectedDestinationToShowGearOptions === d" (click)="$event.stopPropagation()">
            <span class="gear-title">Ported from</span>
            <div class="d-flex align-items-center my-10 gap-10">
              <input
                type="radio"
                name="portedfrom_{{ d.mnc }}_selected"
                class="form-check-input cp"
                [checked]="filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'ALL'"
                (click)="onAllFilterPortedClick(d)" />
              <label>All ported numbers</label>
            </div>
            <div class="d-flex align-items-center my-10 gap-10">
              <input
                type="radio"
                name="portedfrom_{{ d.mnc }}_selected"
                class="form-check-input cp"
                [checked]="filterMccMncPortedMncMap.get(d.mcc + '_' + d.mnc)?.type === 'SPECIFIC'"
                (click)="onSpecificFilterPortedClick(d)" />
              <label>Specific ported MNCs</label>
            </div>
            <div class="w-75 ms-20 mb-15 gap-10">
              <input
                class="form-control"
                type="text"
                placeholder="01,02"
                (input)="onSpecificMNCInputChange($event, d)"
                [formControl]="currentPortedMNCFormControl" />
              <input-errors class="mt-10" [control]="currentPortedMNCFormControl" [service]="validationService"></input-errors>
            </div>
            <div class="gear-buttons d-flex justify-content-end align-items-center gap-10">
              <button class="btn btn-sm btn-outline-dark px-10" (click)="selectedDestinationToShowGearOptions = null; $event.stopPropagation()">
                Cancel
              </button>
              <button
                class="btn btn-sm btn-primary px-10"
                [disabled]="!currentPortedMNCFormControl.valid"
                (click)="onFilterPortedSubmitClick(d); $event.stopPropagation()">
                Submit
              </button>
            </div>
          </div>
        </div>
        <div *ngIf="!selectedModels.length" class="list-row text-center mt-20 text-neutral-n6">No destination selected</div>
      </cdk-virtual-scroll-viewport>
    </div>
  </div>
</div>

<ng-template #addPhonenumbersModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Add custom test numbers</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(false)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>
  <div class="modal-body">
    <div class="alert alert-primary mb-15">
      {{
        source === 'mo'
          ? 'Please note that if the provided test number does not have our software installed, we will not be able to send an MO SMS from it.'
          : 'Please note that if the test number does not have our software installed, we will not be able to provide you with a correct receipt status.'
      }}
    </div>

    <div class="form-group">
      <label for="number" class="form-label">Phone numbers</label>
      <div class="manual-phone-number">
        <textarea id="manualPhoneNumberTextArea" (input)="onManualNumbersChange($event)"></textarea>
      </div>
      <div *ngIf="hasErrorInManualNumber" class="input-errors mt-10">
        <span class="help-block m-b-none text-danger">Only numbers can be entered here.</span>
      </div>
      <div>
        <br />
        <strong>Example:</strong> <br />
        355699669329 <br />
        213699244842 <br />
        542634654556 <br />
        <br />
      </div>
    </div>
    <br />
  </div>
  <div class="modal-footer pt-15">
    <div class="button-holder d-flex justify-content-between">
      <button class="btn btn-outline-dark" (click)="dialogRef.close(false)">Cancel</button>
      <button class="btn btn-primary ms-15" [disabled]="hasErrorInManualNumber" (click)="onSubmitAddPhonenumbers()">Confirm</button>
    </div>
  </div>
</ng-template>

<ng-template #exportModalTpl let-dialogRef="dialogRef">
  <div class="modal-header mb-10">
    <div class="modal-title">
      <h3 class="d-inline-block">Export networks</h3>
      <button type="button" class="btn-close" (click)="dialogRef.close(true)">
        <span class="icon-close"></span>
      </button>
    </div>
  </div>

  <ng-container *ngIf="!exportData.filename">
    <div class="modal-body">
      <div [hidden]="!exportSpinner" class="spinner">
        <div class="sk-spinner sk-spinner-pulse small"></div>
      </div>
      <div class="form-check mb-0_7">
        <input class="form-check-input" type="radio" value="online" [(ngModel)]="exportDays" [ngModelOptions]="{ standalone: true }" />
        <label (click)="exportDays = 'online'" class="form-check-label cp" for="flexRadioDefault1"> Online networks </label>
      </div>
      <div class="form-check mb-0_7">
        <input class="form-check-input" type="radio" value="30days" [(ngModel)]="exportDays" [ngModelOptions]="{ standalone: true }" />
        <label (click)="exportDays = '30days'" class="form-check-label cp" for="flexRadioDefault2"> Active networks in the last 30 days </label>
      </div>
      <div class="form-check mb-15">
        <input class="form-check-input" type="radio" value="90days" [(ngModel)]="exportDays" [ngModelOptions]="{ standalone: true }" />
        <label (click)="exportDays = '90days'" class="form-check-label cp" for="flexRadioDefault2"> Active networks in the last 90 days </label>
      </div>
    </div>
    <div class="modal-footer pt-15">
      <div class="button-holder d-flex justify-content-between">
        <button class="btn btn-outline-dark" (click)="dialogRef.close(true)">Cancel</button>
        <button class="btn btn-primary" (click)="onClickStartExport()"><span class="icon-export"></span> Export</button>
      </div>
    </div>
  </ng-container>

  <div *ngIf="exportData.filename" class="text-center">
    <br />
    File: <strong>{{ exportData.filename }}</strong
    ><br /><br />
    <div class="text-center mb-15">
      <div class="hr-line-dashed"></div>
      <a href="{{ exportData.download_url }}" target="_blank" class="btn btn-primary">Download</a>
    </div>
  </div>
</ng-template>
